import { IMatricola } from "core/interfaces/data/IAssistitoRequest";
import { IOrario } from "core/interfaces/data/IOrariRequest";
import { IPreventivoDetailData } from "core/interfaces/data/IPagamentoRequest";
import { IRegisterData } from "core/interfaces/data/IRegisterRequest";
import { ISession } from "core/interfaces/util/ISession";
import {
	IOrarioProfessionistaSlice,
	IPreventivoDetailDataSlice,
	IRegisterDataSlice,
	IResultPrenotazioneDataSlice,
} from "core/redux/features/dataForm/dataFormSliceInterfaces";
import { ISessionData } from "core/redux/features/session/sessionSliceInterfaces";
import _ from "lodash";
import { PaymentMode } from "types/PaymentMode";

export const getReduxRegisterData = (registerData: IRegisterData) => {
	let tempRegisterData: IRegisterDataSlice;

	tempRegisterData = {
		Nome: registerData.Nome,
		Cognome: registerData.Cognome,
		CodiceFiscale: registerData.CodiceFiscale,
		TelefonoContatti: registerData.TelefonoContatti,
		ConsensoSMS: registerData.ConsensoSMS,
		ConsensoMail: registerData.ConsensoMail,
		Email: registerData.Email,
		Password: registerData.Password,
		Sesso: registerData.Sesso,
		DataNascita: registerData.DataNascita.toWSDateFormat(),
		ComuneNascita: registerData.ComuneNascita,
		Cittadinanza: registerData.Cittadinanza,
		PerFamiliare: registerData.PerFamiliare,
	};

	return tempRegisterData;
};

export const getReduxOrario = (orario: IOrario | undefined) => {
	let tempOrari: IOrarioProfessionistaSlice | undefined;
	if (orario)
		tempOrari = { Da: orario.Da.toWSDateFormat(), A: orario.A.toWSDateFormat(), Professionista: orario.Professionista };

	return tempOrari;
};


// export const getReduxOrarioRevert = (orario: IOrarioSlice | undefined) => {
// 	let tempOrari: IOrario | undefined;
// 	if (orario)
// 		tempOrari = { Da: orario.Da.toDateWS(), A: orario.A.toDateWS(), Professionista: orario.Professionista };

// 	return tempOrari;
// };

export const getReduxSession = (s: ISession | undefined) => {
	let tempSession: ISessionData | undefined;
	if (s) tempSession = { idSessione: s.idSessione, expiredIn: s.expiredIn.toISOString() };
	return tempSession;
};

export const getReduxResultPrenotazioneData = (
	IsError: boolean,
	ResPrenotazione?: IMatricola,
	PrevDetail?: IPreventivoDetailData[],
	PaymentMode?: PaymentMode,
	PaymentSuccess?: boolean,
	IdTransazione?: string
	
) => {
	var resDett = _.map(PrevDetail, (value) => {
		return {
			IguAttivita: value.IguAttivita,
			Attivita: value.Attivita,
			IdOperatore: value.IdOperatore,
			DsOperatore: value.DsOperatore,
			OperatoreGenerico: value.OperatoreGenerico,
			IdCausaleIva: value.IdCausaleIva,
			CausaleIva: value.CausaleIva,
			Da: typeof value.Da === typeof Date ? (value.Da as Date).toWSDateFormat() : value.Da.toString(),
			A: typeof value.A === typeof Date ? (value.A as Date).toWSDateFormat() : value.A.toString(),
		} as IPreventivoDetailDataSlice;
	});

	var res: IResultPrenotazioneDataSlice = {
		IsError: IsError,
		ResPrenotazione: ResPrenotazione,
		PreventivoDetail: resDett,
		PaymentSuccess: PaymentSuccess,
		IdTransazione: IdTransazione,
		PaymentMode: PaymentMode,
	};

	return res;
};
